/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Components
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

function HelpModalScreen() {
  const { t } = useTranslation(["help"]);

  return (
    <Box sx={{ overflow: "scroll", overflowX: "hidden", maxHeight: "85vh", padding: "1rem" }}>
      <Typography variant="h1" mb={2}>
        {t("resources.list.title")}
      </Typography>
      <hr />
      {/*---*/}
      <Typography variant="h3" mt={4} ml={2}>
        {t("resources.list.section_title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("resources.list.body")}
        </Box>
      </Typography>
      {/*---*/}
      <Typography variant="h3" mt={4} ml={2}>
        {t("resources.list.columns_title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("resources.list.columns_body")}
        </Box>
      </Typography>
    </Box>
  );
}

export default HelpModalScreen;
